"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _microsoftCognitiveservicesSpeechSdk = require("microsoft-cognitiveservices-speech-sdk");

var _SpeechToText = require("web-speech-cognitive-services/lib/SpeechServices/SpeechToText");

var _abortController = _interopRequireDefault(require("./external/abort-controller"));

var _createErrorEvent = _interopRequireDefault(require("./createErrorEvent"));

var _createTaskQueue2 = _interopRequireDefault(require("./createTaskQueue"));

var _eventTargetShim = _interopRequireWildcard(require("./external/event-target-shim"));

var _playCognitiveServicesStream = _interopRequireDefault(require("./playCognitiveServicesStream"));

var _playWhiteNoise = _interopRequireDefault(require("./playWhiteNoise"));

var _SpeechSynthesisAudioStreamUtterance = _interopRequireDefault(require("./SpeechSynthesisAudioStreamUtterance"));
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["cancel", "getVoices", "speak"] }] */


function _default(_ref) {
  var _ref$audioConfig = _ref.audioConfig,
      audioConfig = _ref$audioConfig === void 0 ? _microsoftCognitiveservicesSpeechSdk.AudioConfig.fromDefaultMicrophoneInput() : _ref$audioConfig,
      audioContext = _ref.audioContext,
      enableTelemetry = _ref.enableTelemetry,
      _ref$ponyfill = _ref.ponyfill,
      ponyfill = _ref$ponyfill === void 0 ? {
    AudioContext: window.AudioContext || window.webkitAudioContext
  } : _ref$ponyfill,
      recognizer = _ref.recognizer,
      textNormalization = _ref.textNormalization;

  if (!ponyfill.AudioContext) {
    console.warn('botframework-directlinespeech-sdk: This browser does not support Web Audio API. Speech support is disabled.');
    return function () {
      return {};
    };
  }

  return function () {
    var _createSpeechRecognit = (0, _SpeechToText.createSpeechRecognitionPonyfillFromRecognizer)({
      audioConfig: audioConfig,
      createRecognizer: function createRecognizer() {
        return recognizer;
      },
      enableTelemetry: enableTelemetry,
      looseEvents: true,
      textNormalization: textNormalization
    }),
        SpeechGrammarList = _createSpeechRecognit.SpeechGrammarList,
        SpeechRecognition = _createSpeechRecognit.SpeechRecognition;

    if (!audioContext) {
      audioContext = new ponyfill.AudioContext();
    }

    var _createTaskQueue = (0, _createTaskQueue2.default)(),
        cancelAll = _createTaskQueue.cancelAll,
        push = _createTaskQueue.push;

    var SpeechSynthesis = /*#__PURE__*/function (_EventTargetShim) {
      (0, _inherits2.default)(SpeechSynthesis, _EventTargetShim);

      function SpeechSynthesis() {
        (0, _classCallCheck2.default)(this, SpeechSynthesis);
        return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SpeechSynthesis).apply(this, arguments));
      }

      (0, _createClass2.default)(SpeechSynthesis, [{
        key: "cancel",
        value: function cancel() {
          cancelAll();
        } // Returns an empty array.
        // Synthesis is done on the bot side, the content of the voice list is not meaningful on the client side.

      }, {
        key: "getVoices",
        value: function getVoices() {
          return [];
        }
      }, {
        key: "speak",
        value: function speak(utterance) {
          var _push = push(function () {
            var controller = new _abortController.default();
            var signal = controller.signal;
            return {
              abort: controller.abort.bind(controller),
              result: function _callee() {
                var _utterance$audioStrea, format, streamReader;

                return _regenerator.default.async(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        utterance.dispatchEvent(new Event('start'));
                        _context.prev = 1;

                        if (!utterance.audioStream) {
                          _context.next = 8;
                          break;
                        }

                        _utterance$audioStrea = utterance.audioStream, format = _utterance$audioStrea.format, streamReader = _utterance$audioStrea.streamReader;
                        _context.next = 6;
                        return _regenerator.default.awrap((0, _playCognitiveServicesStream.default)(audioContext, format, streamReader, {
                          signal: signal
                        }));

                      case 6:
                        _context.next = 10;
                        break;

                      case 8:
                        _context.next = 10;
                        return _regenerator.default.awrap((0, _playWhiteNoise.default)(audioContext));

                      case 10:
                        _context.next = 16;
                        break;

                      case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](1);

                        if (!(_context.t0.message !== 'aborted')) {
                          _context.next = 16;
                          break;
                        }

                        return _context.abrupt("return", utterance.dispatchEvent((0, _createErrorEvent.default)(_context.t0)));

                      case 16:
                        utterance.dispatchEvent(new Event('end'));

                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, null, null, [[1, 12]]);
              }()
            };
          }),
              result = _push.result; // Catching the error to prevent uncaught promise error due to cancellation.


          result.catch(function (error) {
            if (!/^cancelled/i.test(error.message)) {
              throw error;
            }
          });
        }
      }]);
      return SpeechSynthesis;
    }(_eventTargetShim.default);

    (0, _eventTargetShim.defineEventAttribute)(SpeechSynthesis, 'voiceschanged');
    return {
      SpeechGrammarList: SpeechGrammarList,
      SpeechRecognition: SpeechRecognition,
      speechSynthesis: new SpeechSynthesis(),
      SpeechSynthesisUtterance: _SpeechSynthesisAudioStreamUtterance.default
    };
  };
}